import React, { Component, Fragment } from "react"
import Async from "react-select"
import Field from "../../Common/Field/Field"
import ModuleHeader from "../ModuleHeader"
import Button from "../../Buttons/Button"
import externalLink from "../../../assets/images/external-link.png"
import ButtonIcon from "../../Costing/Button/ButtonIcon"

export default class FabricModule extends Component {
  state = {
    fabric: null,
    SAMPLEREQUEST: {},
    FABRIC: {},
    STATUS: [],
    disabled: false,
    fabricList: [],
    durationFabric: null
  }

  componentWillMount() {
    const {
      SAMPLEREQUEST,
      FABRIC,
      STATUS,
      fabric,
      fabricRadio,
      disabled,
      assignedToList,
      fabricProcess,
      durationFabric,
      fabricList
    } = this.props
    this.setState({
      SAMPLEREQUEST,
      FABRIC,
      STATUS,
      fabric,
      fabricRadio,
      fabricProcess,
      disabled,
      assignedToList,
      durationFabric,
      fabricList
    })
  }
  

  // componentDidMount() {
  //   this.getFabricNumber("")
  // }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(this.state.SAMPLEREQUEST).length !=
      Object.keys(nextProps.SAMPLEREQUEST).length
    ) {
      this.setState({
        SAMPLEREQUEST: nextProps.SAMPLEREQUEST
      })
    }
    if (
      Object.keys(this.state.FABRIC).length !=
      Object.keys(nextProps.FABRIC).length
    ) {
      this.setState({
        FABRIC: nextProps.FABRIC
      })
    }
    if (this.state.STATUS.length != nextProps.STATUS.length) {
      this.setState({
        STATUS: nextProps.STATUS
      })
    }

    if (this.state.assignedToList.length != nextProps.assignedToList.length) {
      this.setState({
        assignedToList: nextProps.assignedToList
      })
    }

    if (this.state.fabric != nextProps.fabric) {
      this.setState({
        fabric: nextProps.fabric
      })
    }
    const { fabricProcess, fabricRadio, durationFabric } = nextProps
    this.setState({
      fabricProcess,
      fabricRadio,
      durationFabric
    })
    const { disabled } = nextProps
    this.setState({
      disabled
    })
    //console.log(this.state.fabric, "fabricPosition");
  }

  // getFabricNumber = value => {
  //   // alert(1)
  //   DevelopmentServices.getFabricNumber(value)
  //     .then(response => {
  //       if (response.status == 200) {
  //         this.setState({ fabricList: response.text.data })
  //       }

  //     })
  //     .catch(error => { })
  // }

  checkValidation = (data, element) => {

    if (
      this.validateArrayObject(this.props.fabric, "fabricPosition", null) &&
      (this.validateArrayObject(this.props.fabric, "fabricNumber", null) ||
        this.validateArrayObject(this.props.fabric, "fabricId", null))
    ) {
      if (data == "save") {
        this.props.createFabric(element)
      } else {
        this.props.completeFabric(element)
      }
    } else {
      this.props.getalertMessage("error", "Please fill all mandatory fields")
    }
  }

  validateArrayObject(data, key, val) {
    let values =
      data.filter(function (x) {
        return x[key] == val
      }).length === 0
        ? true
        : false
    return values
  }
  
  

  render() {
    const { fabric, FABRIC, SAMPLEREQUEST, STATUS } = this.state
    const { permissions } = this.props
   
    return (
      <div
        class="card-filter meeting-min-con"
        id="fabric"
        style={{ marginBottom: ".5%" }}
      >
        <div class="col-md-12">
          <ModuleHeader
            header={"Fabric "}
            durationETA={this.state.durationFabric}
            moduleName={"fabric"}
            process={this.state.fabricProcess}
            updateModulesMain={this.props.updateModulesMain}
            onClick={this.onOpenModal}
            statusList={STATUS}
            _id={this.props._id}
            disabled={this.state.disabled}
          />
          <div
            class="col-md-12 product-form"
            style={{ paddingBottom: "1%" }}
            id="fabricForm"
          >
            <form name="fabricForm">
              <span class="text-center">
                <h6>
                  <b>SAMPLE RELEASE FORM</b>
                  <span
                    class="printer pull-right cursor-hover"
                    onClick={() => this.props.printFabric()}
                  >
                    <a>
                      <i class="fa fa-print" /> Print
                    </a>
                  </span>
                </h6>
              </span>
              <div class="wash-container">
                <div class="col-md-12 no-padding">
                  <div>
                    <div class="col-md-12 nopadding" />
                    <div class="col-md-12 nopadding">
                      <table class="table">
                        <thead class="border-bottom-0">
                          <tr class="border-bottom-0">
                            {/* <th
                                  class="border-bottom-0 text-left"
                                  width="11.1111111111%"
                                >
                                  {" "}
                                  Assigned to
                                </th> */}
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                              style={{paddingLeft: "15px"}}
                            >
                              Fabric ref no
                              <span
                                style={{ fontSize: "1.2rem" }}
                                className="text-danger"
                              >
                                *
                              </span>
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                              style={{paddingLeft: "1px"}}
                            >
                              Fabric Name{" "}
                              {/* <span
                                style={{ fontSize: "1.2rem" }}
                                className="text-danger"
                              >
                                *
                              </span> */}
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Position{" "}
                              <span
                                style={{ fontSize: "1.2rem" }}
                                className="text-danger"
                              >
                                *
                              </span>
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="8.1111111111%"
                            >
                              Base No
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Classification of fabric
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              Quality
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              count&construction
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              fabric origination
                            </th>

                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              {/* <input
                                name="fabricRadio"
                                type="radio"
                                className="filled-in hide-all"
                                id="inHse"
                                value="inHse"
                                checked={this.state.fabricRadio === "inHse"}
                                onChange={e =>this.props.updateSampleRequest("fabricRadio",e.target.value)}
                              />
                              <label for="inHse">In Hse</label> */}
                              {"In Hse"}
                            </th>
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              {/* <input
                                name="fabricRadio"
                                type="radio"
                                className="filled-in hide-all"
                                id="notInHse"
                                value="notInHse"
                                checked={this.state.fabricRadio === "notInHse"}
                                onChange={e =>
                                  this.props.updateSampleRequest(
                                    "fabricRadio",
                                    e.target.value
                                  )
                                }
                              />
                              <label for="notInHse">Not In Hse</label> */}
                              {"Not In Hse"}
                            </th>
                            {/*   <th
                                  class="border-bottom-0 text-left"
                                  width="11.1111111111%"
                                >
                                  Completed Date
                                </th> */}
                            <th
                              class="border-bottom-0 text-left"
                              width="11.1111111111%"
                            >
                              {!this.state.disabled &&
                                (permissions.create || permissions.edit) && (
                                  <ButtonIcon
                                    buttonType="add"
                                    addRemoveFunc={() => this.props.addFabric()}
                                  />
                                )}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.fabric.map((fabricData, index) => {
                            return (
                              <tr key={index}>
                                {/* <td class="border-top-0">
                                  <div class="custom-async-select">
                                    <Async
                                      name="assignedTo"
                                      value={fabricData.assignedTo}
                                      // onInputChange={this.getFabricNumber}
                                      // onChange={(value) => this.props.getFabricInfo(value,index)}
                                      placeholder="Find AssignedTo"
                                      options={this.state.assignedToList}
                                      disabled={true}
                                    />
                                  </div>
                                </td> */}
                                <td class="border-top-0" width="15%">
                                  <div class="custom-async-select inline-external">
                                    <Async
                                      name="fabricNumber"
                                      value={fabricData.fabricNumber}
                                      onInputChange={val =>
                                        this.props.getFabricNumber(val, index)
                                      }
                                      onChange={val =>
                                        this.props.getFabricInfo(val, index)
                                      }
                                      placeholder="Find Fabric"
                                      // onFocus={() =>
                                      //   this.props.clearDummyFabric(index)
                                      // }
                                      options={
                                        fabricData.fabricList ||
                                        this.props.fabricList
                                      }
                                      disabled={this.state.disabled}
                                      onSelectResetsInput={false}
                                      onBlurResetsInput={false}
                                    />
                                  </div>{" "}
                                  <img
                                    className={"external-link cursor-hover"}
                                    src={externalLink}
                                    onClick={() => {
                                      if (fabricData.fabricNumber) {
                                        let action = this.state.disabled && 'view' || 'edit';
                                        let search = "?" + new URLSearchParams({
                                          action: action,
                                          _id: fabricData.fabricNumber,
                                        }).toString()
                                        window.open(`/developmentFabric${search}`, "_blank")
                                      }
                                    }
                                      // this.props.history.push(
                                      //   "/developmentFabric",
                                      //   {
                                      //     action: `${this.props.action}`,
                                      //     _id: fabricData.fabricNumber
                                      //   }
                                      // )
                                    }
                                  />
                                </td>
                                <Field
                          isFormGroup={true}
                          inputType={"text"}
                          inputName={"fabricName"}
                          value={fabricData.fabricName}
                           index={index}
                          // label={"comments"}
                          onChange={this.props.updateFabricName}
                          disabled={this.state.disabled}
                          max={25}
                        />
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="select"
                                    inputName="fabricPosition"
                                    value={fabricData.fabricPosition}
                                    options={SAMPLEREQUEST.POSITION || []}
                                    index={index}
                                    onChange={this.props.updateFabric}
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td class="border-top-0"><p>{fabricData.bNumber}</p></td>
                                <td class="border-top-0">
                                  {/* <Field
                                    isFormGroup={false}
                                    inputType="select"
                                    inputName="classificationOfFabric"
                                    value={fabricData.classificationOfFabric}
                                    options={
                                      FABRIC.CLASSIFICATIONOFFABRIC || []
                                    }
                                    index={index}
                                    onChange={this.props.updateFabric}
                                    disabled={true}
                                  />{" "} */}
                                  <p>{fabricData.classificationOfFabric}</p>
                                </td>
                                <td class="border-top-0">
                                  {/* <Field
                                    isFormGroup={false}
                                    inputType="select"
                                    inputName="quality"
                                    value={fabricData.quality}
                                    options={FABRIC.BASICQUALITY || []}
                                    onChange={this.props.updateFabric}
                                    index={index}
                                    disabled={true}
                                  />{" "} */}
                                  <p>{fabricData.quality}</p>
                                </td>
                                <td class="border-top-0">
                                  {/* <input
                                    type="text"
                                    min="0"
                                    class="form-control"
                                    placeholder=""
                                    name="countconstruction"
                                    value={fabricData.countConstruction}
                                    disabled={true}
                                  />{" "} */}
                                  <p>{fabricData.countAndConstruction}</p>
                                </td>
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="select"
                                    inputName="fabricOrigination"
                                    value={fabricData.fabricOrigination}
                                    options={
                                      SAMPLEREQUEST.FABRICORIGINATION || []
                                    }
                                    index={index}
                                    onChange={this.props.updateFabric}
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td
                                  class="border-top-0"
                                  style={{ padding: "8px 10px" }}
                                >
                                  <Field
                                    isFormGroup={false}
                                    inputType="radio"
                                    inputName={`fabricRadio${index}`}
                                    value={"inHse" + index}
                                    checked={fabricData.fabricRadio === "inHse"}
                                    index={index}
                                    onChange={(name, value) =>
                                      this.props.updateFabric(
                                        "fabricRadio",
                                        "inHse",
                                        index
                                      )
                                    }
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td
                                  class="border-top-0"
                                  style={{ padding: "8px 10px" }}
                                >
                                  <Field
                                    isFormGroup={false}
                                    inputType="radio"
                                    inputName={`fabricRadio${index}`}
                                    value={"notInHse" + index}
                                    checked={
                                      fabricData.fabricRadio === "notInHse"
                                    }
                                    index={index}
                                    onChange={() =>
                                      this.props.updateFabric(
                                        "fabricRadio",
                                        "notInHse",
                                        index
                                      )
                                    }
                                    disabled={this.state.disabled}
                                  />
                                </td>

                                <td
                                  class="border-top-0"
                                // style={{ top: "12px" }}
                                >
                                  {!this.state.disabled &&
                                    (permissions.create ||
                                      permissions.edit) && (
                                      <ButtonIcon
                                        buttonType="clear"
                                        addRemoveFunc={() =>
                                          this.props.removeFabric(index)
                                        }
                                      />
                                    )}
                                </td>
                                {/* <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="select"
                                    inputName="status"
                                    value={fabricData.status}
                                    options={STATUS}
                                    index={index}
                                    onChange={this.props.updateFabric}
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="date"
                                    value={fabricData.ETA}
                                    inputName="ETA"
                                    index={index}
                                    onChange={this.props.updateFabric}
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td class="border-top-0">
                                  <Field
                                    isFormGroup={false}
                                    inputType="date"
                                    value={fabricData.completedDate}
                                    inputName="completedDate"
                                    index={index}
                                    onChange={this.props.updateFabric}
                                    disabled={this.state.disabled}
                                  />
                                </td> */}
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>

                    <div class="col-md-11 no-padding pl-0">
                      <div class="col-md-10 step-one pl-0">
                        <Field
                          isFormGroup={true}
                          inputType={"textarea"}
                          inputName={"fabricComments"}
                          value={this.props.fabricComments}
                          label={"comments"}
                          onChange={this.props.updateSampleRequest}
                          disabled={this.state.disabled}
                        />
                      </div>
                    </div>
                    {!this.state.disabled &&
                      (permissions.create || permissions.edit) && (
                        <div class="col-md-12 no-padding text-center profile-btn">
                          <Button
                            buttonName={"save"}
                            onClick={e => this.checkValidation("save", e)}
                          />
                          <Button
                            buttonName={"Complete"}
                            onClick={e => this.checkValidation("complete", e)}
                          />
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </form>
          </div>
          {/* } */}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/FabricModule/index.js